import { registerFeatureI18n } from '@saas-kit/lib';

import en from './i18n/en/invitations.json';
import ar from './i18n/ar/invitations.json';

registerFeatureI18n('invitations', { en, ar });

export { InvitationsPage } from './InvitationsPage';
export { BackendInvitationsPage } from './BackendInvitationsPage';
